import Store from 'store'

const AdminDashboard = () =>
  import(/* webpackChunkName: admin */ '@/modules/admin/AdminDashboard')
const AdminMain = () =>
  import(/* webpackChunkName: admin */ '@/modules/admin/Main')
const AdminMails = () =>
  import(/* webpackChunkName: admin */ '@/modules/admin/AdminMails/AdminMails')
const AdminChats = () =>
  import(/* webpackChunkName: admin */ '@/modules/admin/AdminChats/AdminChats')
const AdminApproveOrg = () =>
  import(/* webpackChunkName: admin */ '@/modules/admin/ApproveOrg')
const AdminStartupEdit = () =>
  import(/* webpackChunkName: admin */ '@/modules/admin/AdminStartupEdit')
const AdminStartupLinks = () =>
  import(/* webpackChunkName: admin */ '@/modules/admin/AdminStartupLinks')
const AdminStartupFunnel = () =>
  import(/* webpackChunkName: admin */ '@/modules/admin/AdminStartupFunnel')
const AdminOrganizationList = () =>
  import(/* webpackChunkName: admin */ 'modules/admin/AdminOrganizationList')
const AdminProgramList = () =>
  import(/* webpackChunkName: admin */ 'modules/admin/AdminProgramList')
const AdminOrganizationStartupList = () =>
  import(
    /* webpackChunkName: admin */ 'pages/admin/AdminOrganizationStartupList'
  )
const AdminSharedStartupList = () =>
  import(/* webpackChunkName: admin */ 'pages/admin/AdminSharedStartupList')
const AdminEventList = () =>
  import(/* webpackChunkName: admin */ 'modules/admin/AdminEventList')
const AdminEventEdit = () =>
  import(/* webpackChunkName: admin */ 'modules/admin/AdminEventEdit')
const AdminElements = () =>
  import(/* webpackChunkName: admin */ '@/modules/admin/Elements')
const AdminFeatured = () =>
  import(/* webpackChunkName: admin */ '@/pages/admin/AdminFeatured')
const AdminActivityPage = () =>
  import(/* webpackChunkName: admin */ '@/modules/admin/AdminActivityPage')
const AdminUserList = () =>
  import(/* webpackChunkName: admin */ '@/modules/admin/AdminUserList')
const AdminStartupSettings = () =>
  import(/* webpackChunkName: admin */ '@/modules/admin/AdminStartupSettings')
const AdminStartupProfileProgress = () =>
  import(
    /* webpackChunkName: admin */ '@/modules/admin/AdminStartupProfileProgress'
  )
const AdminStartupChangelog = () =>
  import(/* webpackChunkName: admin */ '@/modules/admin/AdminStartupChangelog')
const AdminReactionList = () =>
  import(/* webpackChunkName: admin */ '@/modules/admin/AdminReactionsPage')
const AdminSubscriptionList = () =>
  import(/* webpackChunkName: admin */ '@/pages/admin/AdminSubscriptionList')
const AdminStartupApplicationListPage = () =>
  import(
    /* webpackChunkName: admin */ '@/pages/admin/AdminStartupApplicationListPage'
  )
const AdminMarketplace = () =>
  import(/* webpackChunkName: admin */ '@/pages/admin/AdminMarketplace')

const OrganizationEdit = () =>
  import(
    /* webpackChunkName: admin */ '@/modules/organizations/OrganizationEdit'
  )
const OrganizerProgramDetailsPage = () =>
  import(
    /* webpackChunkName: admin */ '@/modules/dashboard-organizer/ProgramDetailsPage'
  )
const DashboardStartupListPage = () =>
  import(/* webpackChunkName: admin */ '@/modules/startup-list/StartupListPage')
const ProgramEditor = () =>
  import(
    /* webpackChunkName: admin */ '@/modules/dashboard-organizer/ProgramEditor'
  )
const ProgramResults = () =>
  import(
    /* webpackChunkName: admin */ '@/modules/dashboard-organizer/ProgramResults'
  )
const ProgramSettings = () =>
  import(
    /* webpackChunkName: admin */ '@/modules/dashboard-organizer/ProgramSettings'
  )

export const getTitle = (title) => {
  return `${title} | admin`
}

export const updateTitle = (title) => {
  document.title = getTitle(title)
}

export default [
  {
    beforeEnter: async (to, from, next) => {
      const user = await Store.dispatch('user/getUser')
      if (user && user.isAdmin) {
        next()
      } else {
        console.warn('User was not fetched or is not an admin', user)
        next({ name: 'login', query: { next: to.fullPath } })
      }
    },
    path: '/admin',
    name: 'admin',
    component: AdminDashboard,
    redirect: { path: '/admin/approveOrg' },
    children: [
      {
        path: 'main',
        name: 'adminMain',
        redirect: { path: '/admin/approveOrg' },
        component: AdminMain,
        meta: { title: getTitle('Approve Organization') },
      },
      {
        path: 'approveOrg',
        name: 'adminApproveOrg',
        component: AdminApproveOrg,
        meta: { title: getTitle('Approve Organization') },
      },
      {
        path: 'mails',
        name: 'adminMails',
        component: AdminMails,
        meta: { title: getTitle('Mails') },
      },
      {
        path: 'chats-old',
        name: 'adminChatsOld',
        component: AdminChats,
        meta: { title: getTitle('Chats') },
      },
      {
        path: 'chats',
        name: 'adminChats',
        component: AdminChats,
        meta: { title: getTitle('Chats') },
      },
      {
        path: 'users',
        name: 'adminUserList',
        component: AdminUserList,
        meta: { title: getTitle('Users') },
      },
      {
        path: 'subscriptions',
        name: 'adminSubscriptionList',
        component: AdminSubscriptionList,
        meta: { title: getTitle('Users') },
      },
      {
        path: 'startup-applications',
        name: 'adminStartupApplicationList',
        component: AdminStartupApplicationListPage,
        meta: { title: getTitle('Startup applications') },
      },
      {
        path: 'activity',
        name: 'adminActivityPage',
        component: AdminActivityPage,
        meta: { title: getTitle('Users activity') },
      },
      {
        path: 'startups',
        name: 'adminStartupList',
        component: DashboardStartupListPage,
        meta: { title: getTitle('Startups') },
      },
      {
        path: 'shared-startups',
        name: 'adminSharedStartupList',
        component: AdminSharedStartupList,
        props: true,
      },
      {
        path: 'startups/:id',
        name: 'adminStartupEdit',
        component: AdminStartupEdit,
      },
      {
        path: 'startups/:id/links',
        name: 'adminStartupLinks',
        component: AdminStartupLinks,
      },
      {
        path: 'startups/:startupId/funnel',
        name: 'adminStartupFunnel',
        component: AdminStartupFunnel,
        props: true,
      },
      {
        path: 'reactions',
        name: 'adminReactionList',
        component: AdminReactionList,
        meta: { title: getTitle('Reactions') },
      },
      {
        path: 'startups/:id/settings',
        name: 'adminStartupSettings',
        component: AdminStartupSettings,
        props: true,
      },
      {
        path: 'startups/:id/profile-progress',
        name: 'adminStartupProfileProgress',
        component: AdminStartupProfileProgress,
        props: true,
      },
      {
        path: 'startups/:id/changelog',
        name: 'adminStartupChangelog',
        component: AdminStartupChangelog,
        props: true,
      },
      {
        path: 'organizations',
        name: 'adminOrganizationList',
        component: AdminOrganizationList,
        meta: { title: getTitle('Organizations') },
      },
      {
        path: 'organizations/:organizationId',
        name: 'adminOrganizationEdit',
        component: OrganizationEdit,
      },
      {
        path: 'organizations/:organizationId/startups-old',
        name: 'adminOrganizationStartupList',
        component: AdminOrganizationStartupList,
        props: true,
      },
      {
        path: 'organizations/:organizationId/programs',
        name: 'adminOrganizationProgramList',
        component: AdminProgramList,
        props: true,
      },
      {
        path: 'organizations/:organizationId/programs/:programId',
        props: true,
        component: OrganizerProgramDetailsPage,
        children: [
          {
            path: '',
            name: 'adminOrganizationProgramEdit',
            component: ProgramEditor,
            props: true,
          },
          {
            path: 'results',
            name: 'adminOrganizationProgramResults',
            component: ProgramResults,
            props: true,
          },
          {
            path: 'mails',
            name: 'adminOrganizationProgramSettings',
            component: ProgramSettings,
            props: true,
          },
        ],
      },
      {
        path: 'organizations/:organizationId/showrooms',
        name: 'adminOrganizationEventList',
        component: AdminEventList,
        props: true,
      },
      {
        path: 'organizations/:organizationId/showrooms/:eventId',
        name: 'adminOrganizationEventEdit',
        component: AdminEventEdit,
        props: true,
      },
      {
        path: 'marketplace',
        name: 'adminMarketplace',
        component: AdminMarketplace,
        meta: { title: getTitle('Marketplace') },
      },
      { path: 'elements', name: 'adminElements', component: AdminElements },
      {
        path: 'featured',
        name: 'adminFeatured',
        component: AdminFeatured,
        meta: { title: getTitle('Featured') },
      },
    ],
  },
]
